<template>
	<div>
		<textarea ref="mycode" v-model="value"></textarea>
		<!-- <input type="text" @focus="test()"> -->
		<div style="text-align: center;">
			<Button type="primary" @click="sqlrun()">执行</Button>
			<span style="margin-left: 30px;">
				<Button type="warning" @click="sqlclear()">清空</Button>
			</span>
			<Table :columns="columns" :data="data1"></Table>
		</div>

	</div>
</template>
<script>
	import {
		demoRunSql,
	} from '@/network/index.js';

	import "vue-codemirror/node_modules/codemirror/theme/ambiance.css";
	import "vue-codemirror/node_modules/codemirror/lib/codemirror.css";
	import "vue-codemirror/node_modules/codemirror/addon/hint/show-hint.css";
	let CodeMirror = require("vue-codemirror/node_modules/codemirror/lib/codemirror");
	require("vue-codemirror/node_modules/codemirror/addon/edit/matchbrackets");
	require("vue-codemirror/node_modules/codemirror/addon/selection/active-line");
	require("vue-codemirror/node_modules/codemirror/mode/sql/sql");
	require("vue-codemirror/node_modules/codemirror/addon/hint/show-hint");
	require("vue-codemirror/node_modules/codemirror/addon/hint/sql-hint");
	export default {
		data() {
			return {
				editor: null,

				columns: [],
				data1: []

			}
		},
		props: {
			value: {
				type: String,
				default: ''
			},

		},
 
		mounted() {

			let mime = 'text/x-mariadb'
			// let theme = 'ambiance'//设置主题，不设置的会使用默认主题
			this.editor = CodeMirror.fromTextArea(this.$refs.mycode, {
				value: this.value,
				mode: mime, //选择对应代码编辑器的语言，我这边选的是数据库，根据个人情况自行设置即可
				indentWithTabs: true,
				smartIndent: true,
				lineNumbers: true,
				matchBrackets: true,
				cursorHeight: 1,
				lineWrapping: true,
				readOnly: false,
				extraKeys: {
					'Ctrl': 'autocomplete'
				}, //自定义快捷键
				hintOptions: { //自定义提示选项
					// 当匹配只有一项的时候是否自动补全
					completeSingle: false,

				}
			})

			this.editor.setSize(1300, 120) //设置编辑框的尺寸
			//代码自动提示功能，记住使用cursorActivity事件不要使用change事件，这是一个坑，那样页面直接会卡死
			// this.editor.on('inputRead', () => {
			// 	this.editor.showHint()
			// })
		},
		created(){
			this.demoSelet();
		},
		methods: {
			setcolumns() {
				const paramterTemp = {
					sql: this.editor.getValue(),
				};
				let keys = [];
 
				demoRunSql(paramterTemp).then(res => {
						if (res.data.code == 500) {
                            this.$Message.warning(res.data.obj.error);
						} else {
							
							//数据清空
							this.columns = [];
							
							if (res.data.obj.dataList.length > 0) {
								let obj = res.data.obj.dataList[0];
							
								for (var key in obj) {
									keys.push(key);
									this.columns.push({
										title: key + '',
										key: key + '',
										width: 200,
									});
								}
							}
							
						//数据清空
						this.data1 = [];
						let retrunValue = '{}';
						for (var i = 0; i < res.data.obj.dataList.length; i++) {
							//遍历数组
							let retrunValue = {};
							keys.forEach(function(value, key, arr) {
								//

								retrunValue[value] = res.data.obj.dataList[i][value];
							});
							this.data1.push(retrunValue);
						}
					}
				})
			.catch(error => {});
		},
		
		demoSelet() {
				const paramterTemp = {
					sql: 'SELECT * FROM USER_INFO_T;',
				};
				let keys = [];
		 
				demoRunSql(paramterTemp).then(res => {
						if (res.data.code == 500) {
		                    this.$Message.warning(res.data.obj.error);
						} else {
							
							//数据清空
							this.columns = [];
							
							if (res.data.obj.dataList.length > 0) {
								let obj = res.data.obj.dataList[0];
							
								for (var key in obj) {
									keys.push(key);
									this.columns.push({
										title: key + '',
										key: key + '',
										width: 200,
									});
								}
							}
							
						//数据清空
						this.data1 = [];
						let retrunValue = '{}';
						for (var i = 0; i < res.data.obj.dataList.length; i++) {
							//遍历数组
							let retrunValue = {};
							keys.forEach(function(value, key, arr) {
								//
		
								retrunValue[value] = res.data.obj.dataList[i][value];
							});
							this.data1.push(retrunValue);
						}
					}
				})
			.catch(error => {});
		},

		sqlrun() {
			this.setcolumns();
			console.log('sql:' + this.editor.getValue())
		},
		sqlclear() {
			this.editor.setValue('')
		},


	}
	}
</script>
<style>
	.CodeMirror {
		color: black;
		direction: ltr;
		line-height: 22px;
		height: 100%;
	}

	/* 这句为了解决匹配框显示有问题而加 */
	.CodeMirror-hints {
		z-index: 9999 !important;
	}
</style>
